import { render, staticRenderFns } from "./ClientNoteForm.vue?vue&type=template&id=44a9bb8c&"
import script from "./ClientNoteForm.vue?vue&type=script&lang=js&"
export * from "./ClientNoteForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientNoteForm.vue?vue&type=style&index=0&id=44a9bb8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports